import { Flex, SimpleGrid, useMediaQuery } from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import { PRODUCT_CATEGORIES, UNITS } from "../../../../utils/constants";
import CategoriesField from "../../../fields/CategoriesField";
import FileUploadField from "../../../fields/FileUploadField";
import InputField from "../../../fields/InputField";
import MeasurementUnitField from "../../../fields/MeasurementUnitField";
import NumberField from "../../../fields/NumberField";
import PlacesField from "../../../fields/PlacesField";
import { createValidator as validate } from "./validators";

type CreateCommodityFormProps = {
  onSubmit: (...params: any) => void;
  formName?: string;
};

const CreateCommodityForm = (props: CreateCommodityFormProps) => {
  const { onSubmit, formName } = props;
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      mutators={{
        setFile: ([args], state, { changeValue }) => {
          changeValue(state, "file", () => args);
        },
      }}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit} id={formName}>
          <SimpleGrid columns={[1, 1]} spacing={5} p="10">
            <Field name="name" label="Name" component={InputField} />

            <Field
              name="measurementUnit"
              label="Measurement Unit"
              component={MeasurementUnitField}
              options={UNITS}
              menuPortalTarget={document.body}
            />
            <Field
              name="categories"
              label="Categories"
              component={CategoriesField}
              options={PRODUCT_CATEGORIES}
              menuPortalTarget={document.body}
            />
            <Field
              name="retail"
              label="Retail Price"
              min={1}
              component={NumberField}
            />
            <Field
              name="wholeSale"
              label="Whole Sale Price"
              min={0}
              component={NumberField}
            />

            <FileUploadField setFile={props.form.mutators.setFile} />
          </SimpleGrid>
        </form>
      )}
    </Form>
  );
};

export default CreateCommodityForm;
